/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Card, Typography, IconButton, Chip, TextField, MenuItem, Button, CircularProgress, Tooltip } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import EmailIcon from '@mui/icons-material/Email';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventIcon from '@mui/icons-material/Event';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import showToast from '../../components/Hot-Toast/showToast';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { useTMutation } from '../../utils/useTMutation';
import CheckoutForm from './CheckoutForm';
import { STRIPE_PUBLISHED_KEY } from '../../appConstants';
import { useTQuery } from '../../utils/useTQuery';
import { PayoutToBankForm } from '../../components/PayoutForm/PayoutToBankForm';
import { setAllowRefetch } from '../../slice/userSlice';


const stripePromise = loadStripe(STRIPE_PUBLISHED_KEY);
const customStyles = {
    rows: {
        style: {
            minHeight: "45px",
            paddingLeft: "8px",
            paddingRight: "8px",
        },
    },
    headCells: {
        style: {
            backgroundColor: "#f5f5f5",
        },
    },
    cells: {
        style: {
            paddingLeft: "10px",
            paddingRight: "8px",
        },
    },
};

const schema = z.object({
    finalAmount: z
        .string()
        .refine((val) => parseFloat(val) !== 0, {
            message: "Final Amount cannot be zero",
        })
        .transform((val) => parseFloat(val)), // Convert string to number if it's provided
    paymentStatus: z.enum(['Paid', 'Unpaid']),
    totalHours: z.string().optional(),
    transactionDetails: z.string().optional(),
}).superRefine((data, ctx) => {
    if (data.paymentStatus === 'Paid' && !data.transactionDetails?.trim()) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['transactionDetails'],
            message: "Transaction Details is required",
        });
    }
});


const ClinicianTimesheetForPayment = () => {
    const { mappedJobId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userDetails } = useSelector(state => state.user);
    const { USER_TYPE, ID } = userDetails;
    const [selectedRows, setSelectedRows] = useState([]);
    const [clinicianJobTimeSheet, setClinicianJobTimeSheet] = useState({});
    const [paymentSummary, setPaymentSummary] = useState({ totalHours: 0, totalPayment: 0 });
    const [paymentStatus, setPaymentStatus] = useState('Unpaid');
    const [showPaymentGateway, setShowPaymentGateway] = useState(false);
    const [paymentIntent, setPaymentIntent] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);
    const [transactionID, setTransactionID] = useState(null);
    const [openPayoutToBank, setOpenPayoutToBank] = useState(false);
    const { isAllowRefetch } = useSelector((state) => state.user);
    const { data, isLoading, refetch } = useTQuery(
        ["jobTimesheetDetailsById", mappedJobId,],
        mappedJobId ? `/job/jobTimesheetDetailsById?${new URLSearchParams({ ID: mappedJobId, USER_TYPE }).toString()}` : null,
        'get',
        !!mappedJobId,
    );
    const [stripeAccount, setStripeAccount] = useState(null);
    useEffect(() => {
        if (isAllowRefetch) {
            refetch();
            // ✅ Reset the flag so it doesn't keep triggering
            dispatch(setAllowRefetch(false));
        }
    }, [isAllowRefetch]); // run only when refetchData changes

    useEffect(() => {
        if (data?.STATUS) {
            setClinicianJobTimeSheet(data?.OUTPUT);
            console.log("data?.OUTPUT", data?.OUTPUT)
            setStripeAccount(data?.OUTPUT?.clinician?.STRIPE_ACCOUNT_ID);
        } else {
            setClinicianJobTimeSheet({});
        }
    }, [data]);
    console.log("clinicianJobTimeSheet", clinicianJobTimeSheet)
    useEffect(() => {
        if (clinicianJobTimeSheet?.hiringBy !== "Admin") {
            if (selectedRows.length > 0) {
                setPaymentStatus("Paid");
            } else {
                setPaymentStatus("Unpaid");
            }
        }
    }, [clinicianJobTimeSheet?.hiringBy, selectedRows])

    const { register, handleSubmit, setValue, clearErrors, formState: { errors } } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            paymentStatus: 'Unpaid',
            transactionDetails: '',
        },
    });

    useEffect(() => {
        setValue('paymentStatus', paymentStatus, { shouldValidate: true });

        if (paymentStatus === 'Unpaid') {
            clearErrors('transactionDetails');
        }
    }, [paymentStatus, setValue, clearErrors]);



    const calculateTotals = (rows) => {
        const rowIds = rows.map(row => row.ID);
        console.log("rowIds", rowIds)
        const selectedData = clinicianJobTimeSheet?.timesheet?.filter((row) => rowIds.includes(row.ID)) || [];
        console.log("selectedData", selectedData)
        const totalHours = selectedData.reduce((sum, row) => {
            const [hours, minutes] = row.TOTAL_TIME.split(' ').map((part) => parseInt(part.replace(/[^\d]/g, '')));
            return sum + hours + minutes / 60;
        }, 0);

        console.log("totalHours", totalHours);
        const isAdminPaying = selectedData[0]?.HIRING_TYPE === "Request Hire" && USER_TYPE === "admin";
        let RATE = 0;
        RATE = isAdminPaying ? (clinicianJobTimeSheet?.settleRateAdminToClinician) : (clinicianJobTimeSheet?.settleRate);
        console.log("RATE", RATE);
        const totalPayment = totalHours * RATE;
        console.log("totalPayment", totalPayment);
        setPaymentSummary({ totalHours: totalHours.toFixed(2), totalPayment: totalPayment.toFixed(2) });
        setValue('finalAmount', totalPayment.toFixed(2));
        setValue('totalHours', totalHours.toFixed(2));
    };

    const handleCheckboxChange = (event, row) => {
        const isAdminPaying = row?.HIRING_TYPE === "Request Hire" && USER_TYPE === "admin";
        const selectedRowAmount = isAdminPaying ? row.totalPaymentAdminToClinician : row.totalHoursPayment;
        const updatedRows = event.target.checked
            ? [...selectedRows, { ID: row.ID, paymentAmount: selectedRowAmount }]
            : selectedRows.filter(clinicianJobTimeSheet => clinicianJobTimeSheet.ID !== row.ID);
        setSelectedRows(updatedRows);
        calculateTotals(updatedRows); //important
    };

    const renderCell = (value, backgroundColor = "#f0f0f0") => (
        <div style={{ backgroundColor, padding: "5px", borderRadius: "5px" }}>
            {value}
        </div>
    );

    const getTooltipText = (row) => {
        if (row.STATUS === "Uploaded") {
            return "Timesheet is uploaded and cannot be selected for payment";
        }
        if (USER_TYPE === "facility" && row.paymentStatus === "succeeded") {
            return "Payment already processed for this timesheet";
        }
        if (USER_TYPE === "admin" && row.paymentStatusByAdmin === "succeeded") {
            return "Payment already processed for this timesheet";
        }
        return "";
    };

    const isDisabled = (row) => {
        return row.STATUS === "Uploaded"
            || (row.paymentStatus === "succeeded" && USER_TYPE === "facility")
            || (row.paymentStatusByAdmin === "succeeded" && USER_TYPE === "admin");
    };

    const columns = [
        //show to all 
        {
            name: "Select",
            selector: (row) => row.ID,
            cell: (row) => (
                <Tooltip title={getTooltipText(row)} placement="top">
                    <span>
                        <input
                            type="checkbox"
                            disabled={isDisabled(row)}
                            onChange={(e) => handleCheckboxChange(e, row)}
                        />
                    </span>
                </Tooltip>
            ),
        },
        { name: "Service Date", selector: (row) => new Date(row.JOB_DATE).toDateString() },
        {
            name: "Timesheet Status", selector: (row) => row.STATUS,
            cell: (row) => (renderCell(row?.STATUS, row?.STATUS === "Approved" ? "#d4edda" : "red"))

        },
        {
            name: "Total Time", selector: (row) => row.TOTAL_TIME,
            cell: (row) => renderCell(row.TOTAL_TIME, "#d4edda")
        },

        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" ? [
            //show when clinicianJobTimeSheet?.hiringBy === "Admin"
            //it is Request Hiring process
            {
                name: USER_TYPE === "facility" ? "Rate per hrs" : "Rate per hrs (Admin)",
                selector: (row) => `$${clinicianJobTimeSheet?.settleRate}`,
                cell: (row) => (
                    renderCell(clinicianJobTimeSheet?.settleRate,)
                ),
            }
        ] : [
            //show when clinicianJobTimeSheet?.hiringBy === "Facility"
            {//it is Self Hiring process
                name: "Rate per hrs", selector: () => `$${clinicianJobTimeSheet?.settleRate}`,
                cell: (row) => (
                    renderCell(clinicianJobTimeSheet?.settleRate, "#d4edda")

                ),
            }]),

        // Conditionally include the "Payment status" or "Received by Facility" column


        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" ? [
            {
                name: USER_TYPE === "facility" ? "Payment to Admin" : "Total Payment",
                selector: (row) => `$${row.totalHoursPayment}`,
                cell: (row) => (
                    renderCell(row?.totalHoursPayment,)
                ),
            }
        ] : [
            {
                name: "Payment", selector: (row) => `$${row.totalHoursPayment}`,
                cell: (row) => (
                    renderCell(row?.totalHoursPayment, "#d4edda")
                ),
            },
        ]),
        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" ? [
            {
                name: USER_TYPE === "facility" ? "Payment status" : "Received by Facility",
                selector: (row) => `${row.paymentStatus || "Pending"}`,

                cell: (row) => (renderCell(row?.paymentStatus, row?.paymentStatus === "succeeded" ? "#d4edda" : "#f8d7da"))
            }
        ] : [{
            name: "Payment status", selector: (row) => `${row.paymentStatus || "Pending"}`,
            cell: (row) => (renderCell(row?.paymentStatus, row?.paymentStatus === "succeeded" ? "#d4edda" : "#f8d7da"))
        }]),

        //Show to admin
        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" && USER_TYPE !== "facility" ? [
            {
                name: "Rate per hrs (Clinician)",
                selector: (row) => `$${clinicianJobTimeSheet?.settleRateAdminToClinician}`,
                cell: (row) => (
                    renderCell(clinicianJobTimeSheet?.settleRateAdminToClinician, "#d4edda")
                ),
            }
        ] : []),

        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" && USER_TYPE !== "facility" ? [
            {
                name: "Total Payment (Clinician)",
                selector: (row) => `$${row?.totalPaymentAdminToClinician}`,
                cell: (row) => (
                    renderCell(row?.totalPaymentAdminToClinician, "#d4edda")
                ),
            }
        ] : []),
        ...(clinicianJobTimeSheet?.hiringBy !== "Facility" && USER_TYPE !== "facility" ? [
            {
                name: "Payment Status(Clinician)",
                selector: (row) => `${row?.paymentStatusByAdmin || "Pending"}`,
                cell: (row) => (renderCell(row?.paymentStatusByAdmin, row?.paymentStatusByAdmin === "succeeded" ? "#d4edda" : "#f8d7da"))
            }
        ] : []),

    ];
    const handlePaymentStatusChange = (e) => {
        const status = e.target.value;
        setPaymentStatus(status);
        setValue('paymentStatus', status, { shouldValidate: true, shouldDirty: true });
        if (status === 'Unpaid') {
            setValue('transactionDetails', '', { shouldValidate: true });
            clearErrors('transactionDetails');
        }
    };
    //manual Update Transaction Details
    const manualPayClinician = useTMutation("/payment/manual-payment-clinician", "post", (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
        if (data.STATUS) {
            navigate("/facility/timesheet/view-clinicians/" + clinicianJobTimeSheet?.jobID);
        }
    })
    const onSubmitNext = async (formData) => {
        const payload = { ...formData, selectedRows, }
        await manualPayClinician.mutateAsync(payload);
    };

    //Online Transaction
    const mutation = useTMutation("/payment/create-payment-intent", "post", (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
        if (data.STATUS) {
            console.log("data.OUTPUT", data.OUTPUT);
            setPaymentIntent(data.OUTPUT?.paymentIntentId);
            setClientSecret(data.OUTPUT?.clientSecret);
            setTransactionID(data.OUTPUT?.transactionID);
            setShowPaymentGateway(true);
        }
    });
    const generatePaymentIntent = async () => {
        await mutation.mutateAsync({
            senderId: ID, amount: paymentSummary.totalPayment, hours: paymentSummary.totalHours,
            clinicianId: clinicianJobTimeSheet?.clinicianId, selectedRows, mappedJobId: mappedJobId,
        });

    }
    const cancelMutation = useTMutation("/payment/cancel-payment-intent", "post", (data) => {
        showToast(data?.STATUS ? "success" : "error", data.MESSAGE);
        if (data?.STATUS) window.location.reload();
    });

    const cancelPayment = async () => {
        if (!paymentIntent) {
            showToast("error", "No payment intent transaction available.");
            return;
        }
        await cancelMutation.mutateAsync({ paymentIntentId: paymentIntent });
    };

    const sendMoneyAdminToClinician = () => {
        const BankAccounts = clinicianJobTimeSheet?.BankAccounts;
        if (BankAccounts.length <= 0) {
            return showToast('error', "Unable to fetch clinician Bank accounts. ", 3000);
        }
        setOpenPayoutToBank(true);
    }
    const bankAccounts = Array.isArray(clinicianJobTimeSheet?.BankAccounts)
        ? clinicianJobTimeSheet.BankAccounts
        : [];
    // Show loading screen while fetching data
    if (isLoading || data?.STATUS === undefined) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    //   backgroundColor: theme.palette.background.default,
                    textAlign: "center",
                    padding: 3,
                }}
            >
                <CircularProgress size={60} />
            </Box>
        );
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <IconButton onClick={() => navigate(-1)}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography variant="body1">Back</Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Card elevation={3} sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                        {/* Job Information */}
                        <Grid item xs={12} sm={6}>
                            <Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <EventIcon color="action" />
                                    <Typography variant="subtitle1" color="text.secondary">
                                        Start Date: {new Date(clinicianJobTimeSheet?.job?.SERVICE_DATE).toDateString() || 'Date Not Provided'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <WorkIcon color="action" />
                                    <Typography variant="body2" color="text.primary" ml={1}>
                                        Type: {clinicianJobTimeSheet?.job?.SERVICE_TYPE || 'Service Type Unavailable'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <LocationOnIcon color="action" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {clinicianJobTimeSheet?.clinician?.STREET_ADDRESS || 'Address Unavailable'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <ScheduleIcon color="action" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {clinicianJobTimeSheet?.timesheet?.STATUS || "Timesheet & Payments"}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Status Chips */}
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                <Chip
                                    label={clinicianJobTimeSheet?.job?.JOB_TYPE || 'Job Type Unavailable'}
                                    sx={{ backgroundColor: '#eef7e9', fontWeight: 500 }}
                                />
                                <Chip
                                    label={clinicianJobTimeSheet?.job?.JOB_STATUS || 'Job Status Unavailable'}
                                    sx={{ backgroundColor: '#f6b613', color: '#fff', fontWeight: 500 }}
                                />

                                {/* <Chip
                                    label={clinicianJobTimeSheet?.timesheet?.[0]?.STATUS || "Pending Timesheet"}
                                    sx={{
                                        backgroundColor: clinicianJobTimeSheet?.timesheet?.[0]?.STATUS ? 'green' : 'red',
                                        color: '#fff',
                                        fontWeight: 500
                                    }}
                                /> */}

                            </Box>
                        </Grid>

                        {/* Clinician Information */}
                        <Grid item xs={12}>
                            <Box mt={2}>
                                <Typography variant="h6" fontWeight={600} color="text.primary">
                                    Clinician Details
                                </Typography>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <WorkIcon color="action" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {clinicianJobTimeSheet?.clinician?.FULL_NAME || 'Name Unavailable'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <EmailIcon color="action" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {clinicianJobTimeSheet?.clinician?.EMAIL_ADDRESS || 'Email Unavailable'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" mt={1}>
                                    <PhoneIcon color="action" />
                                    <Typography variant="body2" color="text.secondary" ml={1}>
                                        {clinicianJobTimeSheet?.clinician?.PHONE_NUMBER || 'Phone Number Unavailable'}
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>

                        {/* Clinician Bank Information */}
                        <Grid item xs={12}>
                            <Box mt={2}>
                                <Typography variant="h6" fontWeight={600} color="text.primary">
                                    Clinician Bank Information
                                </Typography>
                                {bankAccounts.length > 0 ? (
                                    <Grid container spacing={2} mt={1}>
                                        {bankAccounts.map((account, index) => (
                                            <Grid item xs={12} md={6} key={account?.ID || index}>
                                                <Box
                                                    sx={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: 2,
                                                        p: 2,
                                                        backgroundColor: '#fafafa'
                                                    }}
                                                >
                                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                                        Bank Account {index + 1}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Bank Name: {account?.bankName || '-'}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Account Holder Name: {account?.accountHolderName || '-'}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Routing Number: {account?.routingNumber || '-'}
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Account Number: {account?.accountNumber || '-'}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Typography variant="body2" color="text.secondary" mt={1}>
                                        No bank account details available.
                                    </Typography>
                                )}

                            </Box>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>

            {clinicianJobTimeSheet?.timesheet?.length > 0 &&
                <>
                    <Grid item xs={12}>
                        <Card elevation={3} sx={{ p: 2 }}>
                            <Typography variant="h6">Clinician Timesheet Details</Typography>
                            <DataTable
                                columns={columns}
                                data={clinicianJobTimeSheet.timesheet || []}
                                customStyles={customStyles}
                            />
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card elevation={3} sx={{ p: 2 }}>
                            <Typography variant="h6">Payment Summary</Typography>
                            <Typography>Total Hours: {paymentSummary.totalHours}</Typography>
                            <Typography>Total Payment: ${paymentSummary.totalPayment}</Typography>
                            <form onSubmit={handleSubmit(onSubmitNext)}>
                                <Grid container spacing={2} mt={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Final Payment ($)"
                                            {...register('finalAmount')}
                                            disabled
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            error={!!errors.finalAmount} // Check for errors
                                            helperText={errors.finalAmount ? errors.finalAmount.message : ''} // Show error message
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Total Hours Work"
                                            {...register('totalHours')}
                                            disabled
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            error={!!errors.totalHours} // Check for errors
                                            helperText={errors.totalHours ? errors.totalHours.message : ''}
                                        />
                                    </Grid>
                                    {clinicianJobTimeSheet?.hiringBy !== "Admin" &&
                                        <>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    select
                                                    label="Payment Status"
                                                    value={paymentStatus}
                                                    onChange={handlePaymentStatusChange}
                                                    fullWidth
                                                >
                                                    <MenuItem value="Paid">Paid</MenuItem>
                                                    <MenuItem value="Unpaid">Unpaid</MenuItem>
                                                </TextField>
                                            </Grid>
                                            {paymentStatus === 'Paid' && (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        label="Transaction Details"
                                                        // value={transactionDetails}
                                                        // onChange={(e) => setTransactionDetails(e.target.value)}
                                                        {...register('transactionDetails')}
                                                        fullWidth
                                                        InputLabelProps={{ shrink: true }}
                                                        error={!!errors.transactionDetails} // Check for errors
                                                        helperText={errors.transactionDetails ? errors.transactionDetails.message : ''}
                                                    />
                                                </Grid>
                                            )}
                                        </>
                                    }
                                </Grid>

                                {/* Online Stripe Transaction Functionality */}
                                {showPaymentGateway ? (
                                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                                        <CheckoutForm
                                            p={10}
                                            type="FacilityToAdmin"
                                            transactionID={transactionID}
                                            paymentIntent={paymentIntent}
                                            cancelPayment={cancelPayment}
                                        />
                                    </Elements>
                                ) : (
                                    <Box mt={2}>
                                        {USER_TYPE === "admin" ?
                                            <Button variant="contained" color="primary"
                                                disabled={selectedRows.length === 0}
                                                onClick={sendMoneyAdminToClinician}>
                                                Process to Send Money
                                            </Button>
                                            :
                                            clinicianJobTimeSheet?.hiringBy === "Admin" ? (
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    sx={{ background: "#6EBE44" }}
                                                    disabled={selectedRows.length === 0}
                                                    onClick={generatePaymentIntent}
                                                >
                                                    Proceed to pay
                                                    {paymentSummary.totalPayment > 0 && ` $${paymentSummary.totalPayment}`}
                                                </Button>
                                            ) : (
                                                <Button type="submit" variant="contained" sx={{ background: "#6EBE44" }}>
                                                    Submit
                                                </Button>
                                            )
                                        }
                                    </Box>
                                )}
                            </form>
                        </Card>
                    </Grid>
                </>}

            {openPayoutToBank && <PayoutToBankForm
                open={openPayoutToBank}
                onClose={() => setOpenPayoutToBank(false)}
                data={{
                    BankAccounts: clinicianJobTimeSheet?.BankAccounts,
                    Clinician: clinicianJobTimeSheet?.clinician,
                    Amount: paymentSummary.totalPayment,
                    TotalHours: paymentSummary.totalHours,
                    STRIPE_ACCOUNT_ID: stripeAccount,
                    SelectedRows: selectedRows
                }}
            />}
        </Grid>
    );
};

export default ClinicianTimesheetForPayment;
